import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Badge } from "../components/ui/badge";
import { Switch } from "../components/ui/switch";
import { Plus, Pencil, Trash2, Building2 } from "lucide-react";
import { toast } from "sonner";

export default function Unidades() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ nome: "", cidade: "", estado: "", ativa: true });

  const load = async () => {
    const { data } = await api.get("/comercial/unidades");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const abrirNovo = () => {
    setEditing(null);
    setForm({ nome: "", cidade: "", estado: "", ativa: true });
    setOpen(true);
  };

  const abrirEdicao = (u) => {
    setEditing(u);
    setForm({ nome: u.nome || "", cidade: u.cidade || "", estado: u.estado || "", ativa: !!u.ativa });
    setOpen(true);
  };

  const salvar = async () => {
    if (!form.nome.trim()) {
      toast.error("Nome obrigatório");
      return;
    }
    try {
      if (editing) {
        await api.patch(`/comercial/unidades/${editing.id}`, form);
        toast.success("Unidade atualizada");
      } else {
        await api.post("/comercial/unidades", form);
        toast.success("Unidade criada");
      }
      setOpen(false);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Falha ao salvar");
    }
  };

  const remover = async (u) => {
    if (!window.confirm(`Remover a unidade "${u.nome}"?`)) return;
    try {
      await api.delete(`/comercial/unidades/${u.id}`);
      toast.success("Unidade removida");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Falha ao remover");
    }
  };

  return (
    <div className="space-y-5" data-testid="unidades-page">
      <div className="flex items-end justify-between">
        <div className="flex items-center gap-3">
          <Building2 size={28} style={{ color: "#1B3A6B" }} />
          <div>
            <h1 className="text-3xl font-display font-bold" style={{ color: "#1B3A6B" }}>Unidades de Atuação</h1>
            <p className="text-sm text-muted-foreground">Gerenciar unidades comerciais ({items.length})</p>
          </div>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button onClick={abrirNovo} data-testid="nova-unidade-btn" className="text-white" style={{ background: "#F97316" }}>
              <Plus size={14} className="mr-2" /> Nova unidade
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editing ? "Editar" : "Nova"} unidade</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div>
                <Label>Nome</Label>
                <Input data-testid="unidade-nome" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} placeholder="Ex: Fortaleza" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Cidade</Label><Input value={form.cidade} onChange={(e) => setForm({ ...form, cidade: e.target.value })} /></div>
                <div><Label>UF</Label><Input maxLength={2} value={form.estado} onChange={(e) => setForm({ ...form, estado: e.target.value.toUpperCase() })} /></div>
              </div>
              <div className="flex items-center gap-2">
                <Switch checked={form.ativa} onCheckedChange={(v) => setForm({ ...form, ativa: v })} />
                <Label>Ativa</Label>
              </div>
              <Button data-testid="unidade-save" onClick={salvar} className="w-full text-white mt-2" style={{ background: "#1B3A6B" }}>
                Salvar
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nome</TableHead>
              <TableHead>Cidade</TableHead>
              <TableHead>UF</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((u) => (
              <TableRow key={u.id} data-testid={`unidade-row-${u.id}`}>
                <TableCell className="font-medium">{u.nome}</TableCell>
                <TableCell>{u.cidade || "—"}</TableCell>
                <TableCell>{u.estado || "—"}</TableCell>
                <TableCell><Badge variant={u.ativa ? "default" : "outline"}>{u.ativa ? "Ativa" : "Inativa"}</Badge></TableCell>
                <TableCell className="text-right">
                  <Button size="sm" variant="ghost" onClick={() => abrirEdicao(u)}><Pencil size={14} /></Button>
                  <Button size="sm" variant="ghost" onClick={() => remover(u)}><Trash2 size={14} /></Button>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center py-6 text-muted-foreground">Nenhuma unidade cadastrada.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
